import { Event } from '@mirai/data-sources';
import { dateFormat, useLocale } from '@mirai/locale';
import { Icon, Text, Tooltip, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { DATE_FORMAT } from './TooltipDates.constants';
import * as style from './TooltipDates.module.css';
import { ICON, EVENT } from '../../../../../helpers';

const TooltipDates = ({ captions = [], values = [], ...others }) => {
  const { locale } = useLocale();

  const [timestamp, setTimestamp] = useState(Date.now());

  useEffect(() => {
    const callback = () => {
      setTimestamp(Date.now());
    };
    Event.subscribe(EVENT.OTA_PRICES_READY, callback);

    return () => {
      Event.unsubscribe(EVENT.OTA_PRICES_READY, callback);
    };
  }, []);

  return values.length ? (
    <Tooltip
      pressable
      Template={() => (
        <>
          {values.map((date, index) => (
            <View key={index} row className={style.row}>
              <Text bold small>
                {dateFormat(date, { locale, ...DATE_FORMAT })}
              </Text>
              <Text small>{captions[index]}</Text>
            </View>
          ))}
        </>
      )}
      timestamp={timestamp}
      className={style.tooltip}
    >
      <Icon {...others} paragraph value={ICON.INFO} />
    </Tooltip>
  ) : null;
};

TooltipDates.displayName = 'Mirai:Core:Rates:Item:TooltipDates';

TooltipDates.propTypes = {
  captions: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.any),
};

export { TooltipDates };
